module.exports = __webpack_public_path__ + "static/img/springAndsummer_banner.31a59280.jpg";